import { type Component } from 'vue'

import { Sport, SportId } from '@collector/sportsapi-client-legacy'

import Baseball from '../Sports/Baseball/Baseball.vue'
import Basketball from '../Sports/Basketball/Basketball.vue'
import RugbyLeague from '../Sports/Rugby/RugbyLeague/RugbyLeague.vue'
import RugbyUnion from '../Sports/Rugby/RugbyUnion/RugbyUnion.vue'
import Soccer from '../Sports/Soccer/Soccer.vue'
import Volleyball from '../Sports/Volleyball/Volleyball.vue'

const sportComponentMap = new Map<SportId, Component>([
  [SportId.Soccer, Soccer],
  [SportId.Basketball, Basketball],
  [SportId.Volleyball, Volleyball],
  [SportId.Baseball, Baseball],
  [SportId.Rugby, RugbyUnion],
  [SportId.RugbyLeague, RugbyLeague],
])

export function getSportRelationComponent(sport: Sport): Component {
  const component = sportComponentMap.get(sport.id)

  if (!component) {
    throw Error(`Unsupported sport: "${sport.name}" (id = ${sport.id})`)
  }

  return component
}
